// extracted by mini-css-extract-plugin
export default {"conteiner":"Projects_conteiner__mRbcZ","tittle":"Projects_tittle__lqRiJ","carousel":"Projects_carousel__7+qHs"};